import React from 'react';
import { Container, Image } from 'react-bootstrap';
import styles from './../style/CatalogSection.module.scss';

const CatalogSection = ({ items }) => {

  return (
    <section className={styles.catalogSection}>
      <Container className={styles.container}>
        <h2 className={styles.sectionTitle}>Каталог</h2>
        
        <div className={styles.catalogGrid}>
          {items.map(item => (
            <div 
              key={item.id} 
              className={styles.catalogCard}
            >
              {item.image &&
                <>
                  <Image className={styles.cardContentImage} alt={`Раздел ${item.id}`} src={item.image} width={233} height={106} />
                  <Image className={styles.cardContentImageMob} alt={`Раздел ${item.id} моб.`} src={item.image_mob} width={174} height={106} />
                </>
              }
              <a 
                href={item.link} 
                className={styles.cardContent}
              >
                <div className={styles.cardIcon}>
                  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="33" height="33" rx="16.5" fill="#E4ECEF"/>
                    <path d="M12 21L21 12M21 12H13.8M21 12V19.2" stroke="black" strokeWidth="1.08" strokeLinecap="round"/>
                  </svg>
                </div>
                <h3 className={styles.cardTitle} dangerouslySetInnerHTML={{__html: item.pagetitle}} />
              </a>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CatalogSection;